import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Geometry from '../../geom/Geometry';
import PointGeometryUnion from './PointGeometryUnion';
import hasInterface from '../../../../../hasInterface';
import Collection from '../../../../../java/util/Collection';
import SnapIfNeededOverlayOp from '../overlay/snap/SnapIfNeededOverlayOp';
import InputExtracter from './InputExtracter';
import OverlayOp from '../overlay/OverlayOp';
import CascadedPolygonUnion from './CascadedPolygonUnion';
var UnaryUnionOp = /*#__PURE__*/function () {
  function UnaryUnionOp() {
    _classCallCheck(this, UnaryUnionOp);
    UnaryUnionOp.constructor_.apply(this, arguments);
  }
  _createClass(UnaryUnionOp, [{
    key: "unionNoOpt",
    value: function unionNoOpt(g0) {
      var empty = this._geomFact.createPoint();
      return SnapIfNeededOverlayOp.overlayOp(g0, empty, OverlayOp.UNION);
    }
  }, {
    key: "unionWithNull",
    value: function unionWithNull(g0, g1) {
      if (g0 === null && g1 === null) return null;
      if (g1 === null) return g0;
      if (g0 === null) return g1;
      return g0.union(g1);
    }
  }, {
    key: "extract",
    value: function extract() {
      if (hasInterface(arguments[0], Collection)) {
        var geoms = arguments[0];
        this._extracter = InputExtracter.extract(geoms);
      } else if (arguments[0] instanceof Geometry) {
        var geom = arguments[0];
        this._extracter = InputExtracter.extract(geom);
      }
    }
  }, {
    key: "union",
    value: function union() {
      if (this._geomFact === null) this._geomFact = this._extracter.getFactory();
      if (this._geomFact === null) return null;
      if (this._extracter.isEmpty()) return this._geomFact.createEmpty(this._extracter.getDimension());
      var points = this._extracter.getExtract(0);
      var lines = this._extracter.getExtract(1);
      var polygons = this._extracter.getExtract(2);
      var unionPoints = null;
      if (points.size() > 0) {
        var ptGeom = this._geomFact.buildGeometry(points);
        unionPoints = this.unionNoOpt(ptGeom);
      }
      var unionLines = null;
      if (lines.size() > 0) {
        var lineGeom = this._geomFact.buildGeometry(lines);
        unionLines = this.unionNoOpt(lineGeom);
      }
      var unionPolygons = null;
      if (polygons.size() > 0) unionPolygons = CascadedPolygonUnion.union(polygons);
      var unionLA = this.unionWithNull(unionLines, unionPolygons);
      var union = null;
      if (unionPoints === null) union = unionLA;else if (unionLA === null) union = unionPoints;else union = PointGeometryUnion.union(unionPoints, unionLA);
      if (union === null) return this._geomFact.createGeometryCollection();
      return union;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geomFact = null;
      this._extracter = null;
      if (arguments.length === 1) {
        if (hasInterface(arguments[0], Collection)) {
          var geoms = arguments[0];
          this.extract(geoms);
        } else if (arguments[0] instanceof Geometry) {
          var geom = arguments[0];
          this.extract(geom);
        }
      } else if (arguments.length === 2) {
        var _geoms = arguments[0],
          geomFact = arguments[1];
        this._geomFact = geomFact;
        this.extract(_geoms);
      }
    }
  }, {
    key: "union",
    value: function union() {
      if (arguments.length === 1) {
        if (hasInterface(arguments[0], Collection)) {
          var geoms = arguments[0];
          var op = new UnaryUnionOp(geoms);
          return op.union();
        } else if (arguments[0] instanceof Geometry) {
          var geom = arguments[0];
          var _op = new UnaryUnionOp(geom);
          return _op.union();
        }
      } else if (arguments.length === 2) {
        var _geoms2 = arguments[0],
          geomFact = arguments[1];
        var _op2 = new UnaryUnionOp(_geoms2, geomFact);
        return _op2.union();
      }
    }
  }]);
  return UnaryUnionOp;
}();
export { UnaryUnionOp as default };